__turbopack_context__.v({
  "chipButton": "PractitionerAutocomplete-module__Grv2CW__chipButton",
  "root": "PractitionerAutocomplete-module__Grv2CW__root",
  "scrollRail": "PractitionerAutocomplete-module__Grv2CW__scrollRail",
});
